import {formatter, request} from '@/utils/request';

export namespace Product {
  export const Path = {
    Get: '/expenseapi/product/get',
    GetQueryPo: '/expenseapi/product/getQueryPo',
    SearchLevel1: '/expenseapi/product/searchLevel1',
    AjaxSearchLevel1: '/expenseapi/product/ajaxSearchLevel1',
    SearchLevel2: '/expenseapi/product/searchLevel2',
    AjaxSearchLevel2: '/expenseapi/product/ajaxSearchLevel2',
    SearchLevel3: '/expenseapi/product/searchLevel3',
    AjaxSearchLevel3: '/expenseapi/product/ajaxSearchLevel3',
    SearchLevel4: '/expenseapi/product/searchLevel4',
    AjaxSearchLevel4: '/expenseapi/product/ajaxSearchLevel4',
    SearchSku: '/expenseapi/product/searchSku',
    AjaxSearchSku: '/expenseapi/product/ajaxSearchSku',
    SearchAll: '/expenseapi/product/searchAll',
    AjaxSearchAll: '/expenseapi/product/ajaxSearchAll',
    SearchNoRoot: '/expenseapi/product/searchNoRoot',
    AjaxSearchNoRoot: '/expenseapi/product/ajaxSearchNoRoot',
    GetRoot: '/expenseapi/product/getRoot',
    Query: '/expenseapi/product/query',
    Export: '/expenseapi/product/export',
    Post: '/expenseapi/product/post',
    Delete: '/expenseapi/product/delete',
    QueryForSheet: '/expenseapi/product/queryForSheet',
    ajaxSearchTargetProduct: '/expenseapi/product/ajaxSearchTargetProduct',
    GetProductStructures: '/expenseapi/product/getProductStructures',
    QueryForCompanySheet: '/expenseapi/product/queryForCompanySheet',

  };


  export async function getQueryPo(id: number) {
    if (REACT_APP_ENV == 'dev' || REACT_APP_ENV == 'test') {
      if (!id) {
        alert("只在开发测试环境出现的提示: 参数为空, 禁止调用后端接口, 调用逻辑需处理! 参数ID:" + id);
      }
    }
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ProductQueryPo>>(Path.GetQueryPo, formatter(options));
  }

  export async function get(id: number) {
    if (REACT_APP_ENV == 'dev' || REACT_APP_ENV == 'test') {
      if (!id) {
        alert("只在开发测试环境出现的提示: 参数为空, 禁止调用后端接口, 调用逻辑需处理! 参数ID:" + id);
      }
    }
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.Product>>(Path.Get, formatter(options));
  }

  export async function searchLevel1(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.SearchLevel1, formatter(options));
  }

  export async function ajaxSearchLevel1(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.AjaxSearchLevel1, formatter(options));
  }

  export async function searchLevel2(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.SearchLevel2, formatter(options));
  }

  export async function ajaxSearchLevel2(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.AjaxSearchLevel2, formatter(options));
  }

  export async function searchLevel3(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.SearchLevel3, formatter(options));
  }

  export async function ajaxSearchLevel3(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.AjaxSearchLevel3, formatter(options));
  }

  export async function searchLevel4(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.SearchLevel4, formatter(options));
  }

  export async function ajaxSearchLevel4(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.AjaxSearchLevel4, formatter(options));
  }


  export async function searchAll(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.SearchAll, formatter(options));
  }

  export async function ajaxSearchAll(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.AjaxSearchAll, formatter(options));
  }

  export async function searchSku(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.SearchSku, formatter(options));
  }

  export async function ajaxSearchSku(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.AjaxSearchSku, formatter(options));
  }

  export async function searchNoRoot(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.SearchNoRoot, formatter(options));
  }

  export async function ajaxSearchNoRoot(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product[]>>(Path.AjaxSearchNoRoot, formatter(options));
  }

  export async function getRoot() {
    const options = {
      method: 'GET',
    };
    return request<API.ResponseResult<API.Product>>(Path.GetRoot, formatter(options));
  }

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.Query, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any[]>>(Path.Export, formatter(options));
  }

  export async function post(body: API.Product) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Product>>(Path.Post, formatter(options));
  }

  export async function del(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<boolean>>(Path.Delete, formatter(options));
  }


  // todo 待删除的方法，服务端api已经删除，确认之后前端也删除
  export async function getProductStructures(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.ProductStructureVo[]>>(
      Path.GetProductStructures,
      formatter(options),
    );
  }

  export async function ajaxSearchTargetProduct(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      }
    }
    return request<API.ResponseResult<API.Product[]>>(Path.ajaxSearchTargetProduct, formatter(options));
  }

  export async function queryForSheet(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<Array<any>>>(Path.QueryForSheet, formatter(options));
  }

  export async function queryForCompanySheet(body: API.ProductSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<Array<any>>>(Path.QueryForCompanySheet, formatter(options));
  }
}
export namespace Uom {
  export const Path = {
    Get: '/expenseapi/uom/get',
    Search: '/expenseapi/uom/search',
    GetZeroUom: '/expenseapi/uom/getZeroUom',
  };

  export async function get(uomCode: string) {
    const options = {
      method: 'GET',
      body: {
        uomCode: uomCode
      },
    };
    return request<API.ResponseResult<API.Uom>>(Path.Get, formatter(options));
  }

  export async function search(body: API.UomParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Uom[]>>(Path.Search, formatter(options));
  }

  export async function getZeroUom() {
    const options = {
      method: 'GET',
      body: {},
    };
    return request<API.ResponseResult<API.Uom>>(Path.GetZeroUom, formatter(options));
  }
}

export namespace ProductUom {
  export const Path = {
    getProductUom: '/expenseapi/productUom/getProductUom',
    getProductUomMax: '/expenseapi/productUom/getProductUomMax',
    getProductUomMin: '/expenseapi/productUom/getProductUomMin',
  };

  export async function getProductUom(body: API.ProductUomParam) {
    const options = {
      method: 'POST',
      body: body,
    };
    return request<API.ResponseResult<API.ProductUom>>(Path.getProductUom, formatter(options));
  }

  export async function getProductUomMax(productIds: string) {
    const options = {
      method: 'GET',
      body: {
        productIds
      },
    };
    return request<API.ResponseResult<API.ProductUom>>(Path.getProductUomMax, formatter(options));
  }

  export async function getProductUomMin(productIds: string) {
    const options = {
      method: 'GET',
      body: {
        productIds
      },
    };
    return request<API.ResponseResult<API.ProductUom>>(Path.getProductUomMin, formatter(options));
  }
}
